import React from 'react';
import styled from 'styled-components';
import { alpha } from '@mui/material/styles';
import {
  Typography as MuiTypography,
  Button as MuiButton,
  CircularProgress,
} from '@mui/material';

import { Icon } from 'components/ui';
import SSpinerWrap from '../../../components/styled/SSpinerWrap';

const DeleteButton = styled(
  ({ title, className, icon = true, loading, ...props }) => (
    <MuiButton
      variant="outlined"
      size="small"
      style={{ minWidth: '33px', ...props.style }}
      className={className}
      classes={{ disabled: 'disabled' }}
      {...props}
    >
      {loading ? (
        <SSpinerWrap>
          <CircularProgress size={15} />
        </SSpinerWrap>
      ) : (
        <>
          {icon && <Icon icon="trash-alt" className="icon" mr={title && 10} />}
          {title && (
            <>
              <MuiTypography variant="h5">{title}</MuiTypography>
            </>
          )}
        </>
      )}
    </MuiButton>
  )
)`
  && {
    background-color: ${(props) =>
      alpha(props.theme.palette.warning.main, 0.05)};
    color: ${(props) => props.theme.palette.warning.main};
    border: none;
    height: 32px;

    &.disabled {
      background-color: ${(props) =>
        alpha(props.theme.palette.warning.main, 0.05)};
      color: ${(props) => props.theme.palette.common.white};
      border: none;
    }

    &:hover {
      background-color: ${(props) => props.theme.palette.warning.main};
      color: ${(props) => props.theme.palette.common.white};
      border: none;

      .MuiTypography-root {
        color: ${(props) => props.theme.palette.common.white};
      }
    }

    .icon {
      font-size: 16px;
    }

    .MuiTypography-root {
      color: ${(props) => props.theme.palette.warning.main};
    }
  }
`;

export default DeleteButton;
